import { NameDto } from 'api/Common/Types'

import { CurrencyType } from '../../Wallet/Types/Wallet'

export type InternalResultsIBResultsDto =
  | MarketingCampaignResultsDto
  | LiveRebateInternalResultsDto
  | ClientContestResultsDto

export interface MarketingCampaignResultsDto {
  ibId: string
  ranking: number
  ibCode: string | null
  name: string | null
  country: string | null
  clientsCount: string | null
  contestPoints: string | null
}

export enum IbContestInternalResultsKey {
  ibId = 'IbId',
  ibCode = 'IbCode',
  ranking = 'Ranking',
  country = 'Country',
  clientName = 'Name',
  clientsCount = 'ClientsCount',
  contestPoints = 'ContestPoints',
}

export enum IbContestInternalResultsFilterKey {
  clientName = 'ClientName',
  ibCode = 'Name',
  country = 'Country',
}

export interface ClientContestResultsDto {
  clientId: string
  ranking: number
  clientName: string | null
  contestPoints: number
  login: string | null
  disqualified: boolean
  disqualificationRule: {
    businessRule: NameDto | null
    businessRuleValue: NameDto | null
  }
}
export enum ClientContestResultsKey {
  clientId = 'clientId',
  ranking = 'ranking',
  clientName = 'clientName',
  login = 'login',
  contestPoints = 'contestPoints',
}
export interface LiveRebateInternalResultsDto {
  clientId: string
  ranking: number
  client: string | null
  login: string | null
  volume: number
  rebate: number
  totalVolume: number
  totalRebate: number
  disqualified: boolean
  disqualificationRule: {
    businessRule: NameDto | null
    businessRuleValue: NameDto | null
  }
}

export enum LiveRebateInternalResultsKey {
  clientId = 'clientId',
  ranking = 'ranking',
  client = 'client',
  login = 'login',
  volume = 'volume',
  rebate = 'rebate',
  totalVolume = 'totalVolume',
  totalRebate = 'totalRebate',
}

export enum LiveRebateInternalResultsFilterKey {
  clientName = 'ClientName',
  login = 'Login',
}

export enum LiveRebateInternalResultsSortKey {
  ranking = 'Rank',
  contestPoints = 'ContestPoints',
  clientCount = 'ClientCount',
  country = 'IntroducingBroker.Client.Country.Name',
  clientName = 'IntroducingBroker.Client.Name',
}

export enum IbContestInternalResultsSortKey {
  ranking = 'Rank',
  contestPoints = 'ContestPoints',
  clientCount = 'ClientCount',
  country = 'IntroducingBroker.Client.Country.Name',
  clientName = 'IntroducingBroker.Client.Name',
}

export enum LuckyDrawRewardDetailsKey {
  Number = 'number',
  RewardType = 'rewardType.name',
  Currency = 'currency.id',
  Reward = 'reward',
  TopPrize = 'topPrize',
  RewardChanceWeight = 'rewardChanceWeight',
}

export interface LuckyDrawRewardsDto {
  id: string
  number: number
  rewardType: {
    id: number
    name: string
  }
  currency: {
    id: CurrencyType
    name: string
  } | null
  reward: number
  topPrize: boolean
  rewardChanceWeight: number
}

export interface LuckyDrawRewardTypeDto {
  id: number
  name: string
}

export interface LuckyDrawActivityTypeDto {
  id: number
  name: string
}

export interface LuckyDrawResultDto {
  id: string
  campaignId: string
  clientId: string
  clientName: string
  activityId: number
  activity: string
  result: string
  createdAt: string
}

export interface MarginBonusResultDto {
  id: string
  campaignId: string
  client: NameDto
  tradingAccount: NameDto<string>
  walletId: string

  netDeposit: number
  status: NameDto
  credit: number
}

export enum MarginBonusResultsFilterKey {
  clientName = 'ClientName',
  account = 'Account',
  netDeposit = 'NetDeposit',
  status = 'Status',
}

export enum MarginBonusDetailsKey {
  ClientName = 'Client Name',
  Account = 'Account',
  NetDeposit = 'Net Deposit',
  Status = 'Status',
}
